import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditServiceOrdersForm from './EditServiceOrdersForm'
import ModalHeader from './ModalHeader'
import ServiceOrdersLoader from './_load/ServiceOrdersLoader'
import PlacesLoader from './_load/PlacesLoader'

const EditServiceOrdersModal = props => {
  return (
    <ControlledModal fullScreen noPadding {...props}>
      <ModalHeader />

      <PermissionChecker any={['createServiceOrder', 'editServiceOrder']}>
        <PlacesLoader>
          <ServiceOrdersLoader>
            <EditServiceOrdersForm />
          </ServiceOrdersLoader>
        </PlacesLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditServiceOrdersModal
